/**
 * Seasonal header themes for PriceCompare.
 *
 * All dates are auto-calculated. Zero manual maintenance needed.
 * - Fixed dates: { month, day }
 * - Dynamic holidays: { holiday: 'easter'|'blackfriday', offset: days }
 *
 * To add/remove a season: edit this array. No other code changes needed.
 */
export const headerThemes = [
    {
        name: 'newyear',
        label: 'Godt Nytår',
        from: { month: 12, day: 28 },
        to: { month: 1, day: 2 },
        headerBg: 'linear-gradient(135deg, #0A0C10 0%, #1a1040 100%)',
        gradientLine: 'linear-gradient(90deg, #FFD700, #FF6B6B, #00B4D8, #FFD700)',
        animation: 'fireworks',
        animationIntensity: 'high',
    },
    {
        name: 'valentines',
        label: 'Valentins Dag',
        from: { month: 2, day: 10 },
        to: { month: 2, day: 15 },
        headerBg: 'linear-gradient(135deg, #1a0a10 0%, #2a0a1a 100%)',
        accentOverride: '#E91E63',
        gradientLine: 'linear-gradient(90deg, #E91E63, #FF6B9D, #E91E63)',
        animation: 'hearts',
        animationIntensity: 'low',
    },
    {
        name: 'easter',
        label: 'God Påske',
        from: { holiday: 'easter', offset: -7 },
        to: { holiday: 'easter', offset: 1 },
        headerBg: 'linear-gradient(135deg, #0f1a0a 0%, #1a1a05 100%)',
        accentOverride: '#8BC34A',
        gradientLine: 'linear-gradient(90deg, #8BC34A, #FFD54F, #FF8A65, #8BC34A)',
        animation: 'eggs',
        animationIntensity: 'low',
    },
    {
        name: 'summer',
        label: 'Sommer',
        from: { month: 6, day: 20 },
        to: { month: 8, day: 1 },
        headerBg: 'linear-gradient(135deg, #0A0C10 0%, #0a1520 100%)',
        gradientLine: 'linear-gradient(90deg, #00B4D8, #06D6A0, #FFB703, #06D6A0, #00B4D8)',
        animation: null,
        animationIntensity: null,
    },
    {
        name: 'backtoschool',
        label: 'Back to School',
        from: { month: 8, day: 1 },
        to: { month: 8, day: 21 },
        headerBg: 'linear-gradient(135deg, #0A0C10 0%, #0a1018 100%)',
        gradientLine: 'linear-gradient(90deg, #2563EB, #06D6A0, #2563EB)',
        animation: null,
        animationIntensity: null,
    },
    {
        name: 'halloween',
        label: 'Halloween',
        from: { month: 10, day: 20 },
        to: { month: 11, day: 2 },
        headerBg: 'linear-gradient(135deg, #0a0a0a 0%, #1a0f00 100%)',
        accentOverride: '#FF6D00',
        gradientLine: 'linear-gradient(90deg, #FF6D00, #9C27B0, #FF6D00)',
        animation: 'bats',
        animationIntensity: 'low',
    },
    {
        name: 'singles-day',
        label: 'Singles Day',
        from: { month: 11, day: 9 },
        to: { month: 11, day: 12 },
        headerBg: 'linear-gradient(135deg, #1a0505 0%, #0A0C10 100%)',
        accentOverride: '#FF1744',
        gradientLine: 'linear-gradient(90deg, #FF1744, #FFD700, #FF1744)',
        animation: 'sparkle',
        animationIntensity: 'medium',
    },
    {
        name: 'blackfriday',
        label: 'Black Friday',
        from: { holiday: 'blackfriday', offset: -4 },
        to: { holiday: 'blackfriday', offset: 0 },
        headerBg: 'linear-gradient(135deg, #050505 0%, #0a0a00 100%)',
        accentOverride: '#FFD700',
        gradientLine: 'linear-gradient(90deg, #FFD700, #FF4500, #FFD700)',
        animation: 'sparkle',
        animationIntensity: 'medium',
    },
    {
        name: 'cybermonday',
        label: 'Cyber Monday',
        from: { holiday: 'blackfriday', offset: 1 },
        to: { holiday: 'blackfriday', offset: 4 },
        headerBg: 'linear-gradient(135deg, #050510 0%, #0a0520 100%)',
        accentOverride: '#00B4D8',
        gradientLine: 'linear-gradient(90deg, #00B4D8, #06D6A0, #00B4D8)',
        animation: 'sparkle',
        animationIntensity: 'low',
    },
    {
        name: 'christmas',
        label: 'Glædelig Jul',
        from: { month: 12, day: 1 },
        to: { month: 12, day: 27 },
        headerBg: 'linear-gradient(135deg, #1a0a0a 0%, #0f1a0a 100%)',
        accentOverride: '#C41E3A',
        gradientLine: 'linear-gradient(90deg, #C41E3A, #2D5A27, #C41E3A, #2D5A27)',
        animation: 'snow',
        animationIntensity: 'medium',
    },
];
